module.exports = __webpack_public_path__ + "img/sankaku_99_red.8050126c.png";